import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { ReleaseListView } from '@/components/pages/news/ReleaseListView';
import Layout from '@/container/Layout';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { isGuest } from '@/utils/resources/auth/authResource';
import { getAbsolutePath, releaseListPath } from '@/utils/router/links';
const title = 'ニュース一覧 | PROFFIT';
const description = 'PROFFITはコンサル選定支援サービスです。累計80億円以上のコンサル相談実績があり、500社以上のコンサルティング会社から依頼内容や費用水準に合わせて最適なコンサルチームを選定することが出来ます。';
/**
 * ニュース一覧ページ
 * @param props
 * @returns
 */
export const ReleaseListPage = (props) => {
    const { currentPage, loading, onChangePage, releaseList, totalPageCount } = props;
    const { auth } = useTypeSelector((state) => state);
    const isGuestUser = isGuest(auth);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: 'article', property: 'og:type' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: getAbsolutePath(releaseListPath()), property: 'og:url' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(ReleaseListView, { currentPage: currentPage, isGuestUser: isGuestUser, loading: loading, onChangePage: onChangePage, releaseList: releaseList, totalPageCount: totalPageCount })] })));
};
